var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page',{attrs:{"image_source":_vm.image_source,"image_height":_vm.image_height,"main_filters":""}},[_c('br'),_c('br'),_c('br'),_c('br'),_c('a-test-app',{ref:"a-test-app"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }